import _ from 'lodash';

export const camelCase = (str) => {
  const remaining = _.split(str, '_');
  const first = remaining.shift();

  remaining.forEach((item, idx) => {
    remaining[idx] = item[0].toUpperCase() + item.slice(1);
  });

  return first + remaining.join('');
};
